import icons from '@/assets/icons.json'

/**
 * Gets desired svg icon by name
 * @param {String} name of icon
 * @returns {String} svg
 */
export const getIcon = name => icons[name]

/**
 * Luhn algorithm in JavaScript: validate credit card number supplied as string of numbers
 * @author ShirtlessKirk. Copyright (c) 2012.
 * @license WTFPL (http://www.wtfpl.net/txt/copying)
 */
export const luhnChk = (function (arr) {
  return function (ccNum) {
    var len = ccNum.length
    var bit = 1
    var sum = 0
    var val

    while (len) {
      val = parseInt(ccNum.charAt(--len), 10)
      // eslint-disable-next-line no-cond-assign
      sum += (bit ^= 1) ? arr[val] : val
    }

    return sum && sum % 10 === 0
  }
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]))

/**
 * Check object for emptyness
 * @param {Object} obj
 * @returns Boolean
 */
export const isObjectEmpty = (obj = {}) => {
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

/**
 * Transforms file object to
 * base64 string
 * @param {Object} file
 * @returns String
 */
export const fileToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})

/**
 * Creates an array of elements
 * split into groups the length of size.
 *
 * @param {Array} arr
 * @param {Number} chunkSize
 * @returns Array
 */
export const chunk = (arr = [], chunkSize = 0) => arr.reduce(
  (resultArray, item, index) => {
    const chunkIndex = Math.floor(index / chunkSize)

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []
    }

    resultArray[chunkIndex].push(item)
    return resultArray
  }, []
)

export function debounce (f, ms) {
  let isCooldown = false

  return function () {
    if (isCooldown) return

    f.apply(this, arguments)

    isCooldown = true

    // eslint-disable-next-line no-return-assign
    setTimeout(() => isCooldown = false, ms)
  }
}

export const matchMedia = (r1, r2) => {
  // Desktop
  if (window.matchMedia('(min-width: 1000px)').matches) {
    return r1
  }

  // Mobile
  if (window.matchMedia('(max-width: 1000px)').matches) {
    return r2
  }
}
